import { render } from "./answer.vue?vue&type=template&id=e792e5aa"
const script = {}

import "./answer.vue?vue&type=style&index=0&id=e792e5aa&lang=css"

import exportComponent from "D:\\work\\5. H5落地页\\landing_page_h5\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__